import { Component, OnInit, OnDestroy } from '@angular/core';
import { PershingTranslationService } from '@pershing/pershing-core';
import { NxiNavigation, PortalNavigationService } from '@pershing/nxi-ng-common';

@Component({
    selector: 'fourthlevel-navigation',
    templateUrl: 'fourthlevel-navigation.component.html'
})
export class FourthLevelComponent implements OnInit, OnDestroy {
    fourthNavLinks: any[];
    selectedFourthPageId: any;
    navigation: NxiNavigation;
    layout: string;
    constructor(private translationService: PershingTranslationService, private navigationService: PortalNavigationService) { }
    ngOnInit(): void {
        console.log(' In Component OnInit ');
        this.navigationService.getGrandChildPage().subscribe(
            thirdlevelpage => {
                console.log('currentpage', thirdlevelpage);
                if (thirdlevelpage !== undefined) {
                    // this.selectedFourthPageId = currentpage.id;
                    if (thirdlevelpage.children !== undefined) {
                        this.fourthNavLinks = thirdlevelpage.children;
                        if (this.fourthNavLinks.length > 0) {
                            this.selectedFourthPageId = this.fourthNavLinks[0].id;
                            this.layout = this.fourthNavLinks[0].layout;
                            // console.log(' 4rd grandchildpage-- ' + this.selectedFourthPageId);
                            console.log('fourthNavLinks', this.fourthNavLinks);
                        }
                    }
                }
            });
        this.navigationService.getFourthChildPage().subscribe(
            fourthchildpage => {
                if (fourthchildpage) {
                    this.selectedFourthPageId = fourthchildpage.id;
                }
                console.log(' 4th childpage-- ' + fourthchildpage);
            }
        );
    }
    public ngOnDestroy() {
        console.log(' In FourthLevelComponent Destroy ');
    }
    handleFourthLevelNavigation(fourthchildpage): void {
        this.navigation = new NxiNavigation();
        this.navigation.fourthchildPage = fourthchildpage;
        this.navigationService.handleNavigation(this.navigation);
    }
}
